import { Button } from "baseui/button";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "baseui/modal";
import { useState } from "react";
import { CreateObjectInstanceCommand,  useCreateObjectMutation } from "../../../../services/objects";
import AddEdgeDeviceForm from "./AddEdgeDeviceForm";
import { schema } from '..'
import { useReportMutationState } from "../../../../hooks/useReportMutationState";

export interface AddEdgeDeviceDialogProps {
    parentId: string;
    parentResouceGroupId: string;
    isOpen: boolean;
    setIsOpen: any;
    onCreated: any;
}

const AddEdgeDeviceDialog = ({ parentId, parentResouceGroupId, isOpen, setIsOpen, onCreated }: AddEdgeDeviceDialogProps) => {

    const [deviceName, setDeviceName] = useState('');
    const [description, setDescription] = useState('');
    const [createObject, createObjectResult] = useCreateObjectMutation();

    useReportMutationState(createObjectResult,onCreated);
    function onCreateClick(): void {

        const cmd: CreateObjectInstanceCommand = {
            name: deviceName,
            resourceGroupId: parentResouceGroupId,
            description: description,
            schema: schema,
            parentId: parentId,
            properties: [
                { key: 'NoConnection', value: true }
            ],
            sourceRelations: [{ targetId: parentId, relationName: 'IsConnectedTo'}]
        }
        createObject(cmd);
    }

    return (

        <Modal closeable onClose={() => setIsOpen(false)} isOpen={isOpen}>
            <ModalHeader>Add a new Edge Device</ModalHeader>
            <ModalBody>
                <AddEdgeDeviceForm description={description} onDescriptionChanged={(e) => setDescription(e.target.value)} parentId={parentId} parentResouceGroupId={parentResouceGroupId} edgeDeviceId={deviceName} onEdgeDeviceIdChanged={(e) => setDeviceName(e.target.value)}></AddEdgeDeviceForm>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onCreateClick} isLoading={createObjectResult.isLoading}>Add</Button>
            </ModalFooter>
        </Modal>

    )
}

export default AddEdgeDeviceDialog;